
import {IProduct} from "@/types/models/IProduct";
import {PropType} from 'vue';
import ProductItem from "@/components/products/product-item.vue";

export default {
  name: "product-list",
  components: {ProductItem},
  props: {
    products: Object as PropType<IProduct[]>
  }
}
